import moment from "moment";
import { Modal } from "./boxModal";
import { useEffect, useState } from "react";

export function ManualReceiptModal({
  isOpen,
  onClose,
  data,
  onConfirm,
  photoModalClose
}) {
  const [form, setForm] = useState({
    issueDate: "",
    emitterCNPJ: "",
    emitterName: "",
    totalValue: "",
  });

  useEffect(() => {
    if (isOpen && data) {
      setForm({
        issueDate: data?.issueDate
          ? moment(data.issueDate).format("YYYY-MM-DD")
          : "",
        emitterCNPJ: data?.emitterCNPJ || "",
        emitterName: data?.emitterName || "",
        totalValue: data?.totalValue || "",
      });
    }
  }, [isOpen, data]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleSubmit() {
    onConfirm(form);
    onClose();
    photoModalClose()
  }

  const isFormValid =
    form.issueDate.trim() !== "" &&
    form.emitterCNPJ.trim() !== "" &&
    form.emitterName.trim() !== "";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Preencher Informações Adicionais"
      showCancelButton
      onConfirm={handleSubmit}
      confirmDisabled={!isFormValid}
    >
      <div className="flex flex-col gap-4" style={{ color: "black" }}>
        <div>
          <label>Data de Emissão *</label>
          <input
            name="issueDate"
            disabled
            value={form.issueDate}
            onChange={handleChange}
            className="border p-2 rounded w-full"
            type="date"
          />
        </div>

        <div>
          <label>CNPJ do Emissor *</label>
          <input
            name="emitterCNPJ"
            disabled
            value={form.emitterCNPJ}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </div>

        <div>
          <label>Nome do Emissor *</label>
          <input
            name="emitterName"
            value={form.emitterName}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          />
        </div>

        <div>
          <label>Valor Total *</label>
          <input
            name="totalValue"
            value={form.totalValue}
            disabled
            className="border p-2 rounded w-full bg-gray-200 text-gray-700"
          />
        </div>
      </div>
    </Modal>
  );
}
